module.exports = __webpack_public_path__ + "static/media/camera.bbeb9489.svg";